export default __webpack_public_path__ + "static/media/cert-general-staff-cpttm.034bf13a.jpg";